import { createSlice } from '@reduxjs/toolkit'

const dialogSlice = createSlice({
  name: 'dialog',
  initialState: {
    items: {},
  },
  reducers: {
    show(state, { payload: id }) {
      state.items[id] = true
    },
    hide(state, { payload: id }) {
      delete state.items[id]
    },
  },
})

export const Dialogs = {
  show: dialogSlice.actions.show,
  hide: dialogSlice.actions.hide,
}

export default dialogSlice.reducer
